import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["results", "name", "phone"]
  static values = { url: String }

  search(event) {
    clearTimeout(this.timer)
    this.abort?.abort()
    const query = event.target.value.trim()
    this.query = query
    this.resultsTarget.replaceChildren()
    if (query.length < 2) return
    this.timer = setTimeout(async () => {
      this.abort = new AbortController()
      try {
        const response = await fetch(`${this.urlValue}?q=${encodeURIComponent(query)}`, {signal: this.abort.signal, headers: {Accept: "application/json"}})
        if (!response.ok) return
        const customers = await response.json()
        if (this.query !== query) return
        this.resultsTarget.replaceChildren()
        customers.forEach(customer => {
          const button = document.createElement("button")
          button.type = "button"
          button.className = "list-group-item list-group-item-action"
          button.textContent = `${customer.name} · ${customer.phone}`
          button.addEventListener("click", () => {
            if (this.nameTarget.readOnly) return
            this.nameTarget.value = customer.name
            this.phoneTarget.value = customer.phone
            this.phoneTarget.dispatchEvent(new Event("input", {bubbles: true}))
            this.resultsTarget.replaceChildren()
          })
          this.resultsTarget.append(button)
        })
        if (!customers.length) {
          this.resultsTarget.textContent = "Клиент не найден. Заполните данные ниже."
          if (/^[+\d\s().-]+$/.test(query) && /\d/.test(query) && !this.phoneTarget.readOnly &&
              (!this.phoneTarget.value || this.phoneTarget.value === this.transferredPhone)) {
            this.phoneTarget.value = query
            this.phoneTarget.dispatchEvent(new Event("input", {bubbles: true}))
            this.transferredPhone = this.phoneTarget.value
            this.resultsTarget.textContent = "Клиент не найден. Номер перенесён в поле телефона — проверьте его и укажите имя клиента."
          }
        }
      } catch (error) { if (error.name !== "AbortError") this.resultsTarget.textContent = "Поиск недоступен. Можно ввести данные вручную." }
    }, 250)
  }

  disconnect() { clearTimeout(this.timer); this.abort?.abort() }
}
